
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { headerHeight } from "../../NavBars/Header/hardCodeData";
import bannerImage from "../../Images/Service/banner-video-back-Pc.png";
import subBannerImage from "../../Images/Service/pc11.jpg";
import image01 from "../../Images/Service/image-01-Mob.png";
import image02 from "../../Images/Service/image-02-pc.jpg";
import image03 from "../../Images/Service/image-03-pc.jpg";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const Service = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${headerHeight})`,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
             {/* Hero Section with Banner */}
       <Box
         sx={{
           width: "100%",
           display: "flex",
           flexDirection: "column",
           mt: headerHeight,
         }}
       >
         {/* Text Section */}
         <Box
           sx={{
             height: { xs: "100vw", md: "780px", lg: "800px" },
             width: "100%",
             display: "flex",
             flexDirection: "column",
             alignItems: "center",
             justifyContent: "start",
             backgroundImage: {
               xs: `url(${bannerImage})`,
               md: `url(${bannerImage})`,
             },
             backgroundSize: "cover",
             backgroundRepeat: "no-repeat",
             backgroundPosition: "center center",
             position: "relative",
             "&::before": {
               content: '""',
               position: "absolute",
               top: 0,
               left: 0,
               right: 0,
               bottom: 0,
               background: "rgba(0, 0, 0, 0.4)",
               zIndex: 1,
             },
           }}
         >
           <Box
             sx={{
               position: "relative",
               zIndex: 2,
               textAlign: "center",
               px: { xs: 2, md: 4 },
               mt: { xs: 4, md: 10 },
             }}
           >
             <Typography
               sx={{
                 fontFamily: "Montserrat",
                 fontSize: { xs: "5vw", md: "34px" },
                 color: "#fff",
                 fontWeight: 600,
                 letterSpacing: "-2px",
                 textTransform: "uppercase",
                 mb: { xs: 1, md: 2 },
               }}
             >
               {t("service:title")}
             </Typography>
             <Typography
               sx={{
                 fontFamily: "Montserrat",
                 fontSize: { xs: "3vw", md: "16px" },
                 color: "#fff",
                 fontWeight: 400,
                 maxWidth: { xs: "90%", md: "800px" },
                 mx: "auto",
                 lineHeight: 1.4,
               }}
             >
               {t("service:subtitle")}
             </Typography>
           </Box>
         </Box>

         {/* Large Image Section */}
         <Box
           sx={{
             width: "100%",
             display: "flex",
             justifyContent: "center",
             mt: { xs: "-53vw", md: "-500px", lg: "-520px" },
             zIndex: 2,
           }}
         >
           <img
             src={subBannerImage}
             alt="BYD Service"
             style={{
               width: "100%",
               maxWidth: "1200px",
               height: "auto",
               objectFit: "cover",
             }}
           />
         </Box>
       </Box>

      {/* Main Content Sections */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        {/* Section 1: Diagnostics */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            mb: { xs: 8, md: 12 },
            gap: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 1, md: 1 },
            }}
          >
            <img
              src={image01}
              alt="BYD Diagnostics"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 2, md: 2 },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "6vw", md: "36px" },
                fontWeight: 600,
                color: "#000",
                mb: 3,
                textTransform: "uppercase",
              }}
            >
              {t("service:diagnostics_title")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "4vw", md: "18px" },
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              {t("service:diagnostics_description")}
            </Typography>
          </Box>
        </Box>

        {/* Section 2: Spare Parts */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            mb: { xs: 8, md: 12 },
            gap: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 2, md: 1 },
              textAlign: { xs: "center", md: "right" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "6vw", md: "36px" },
                fontWeight: 600,
                color: "#000",
                mb: 3,
                textTransform: "uppercase",
              }}
            >
              {t("service:parts_title")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "4vw", md: "18px" },
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              {t("service:parts_description")}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 1, md: 2 },
            }}
          >
            <img
              src={image02}
              alt="BYD Spare Parts"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box>
        </Box>

        {/* Section 3: Full Service */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            mb: { xs: 8, md: 12 },
            gap: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 1, md: 1 },
            }}
          >
            <img
              src={image03}
              alt="BYD Full Service"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            sx={{
              flex: { xs: "1", md: "1" },
              order: { xs: 2, md: 2 },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "6vw", md: "36px" },
                fontWeight: 600,
                color: "#000",
                mb: 3,
                textTransform: "uppercase",
              }}
            >
              {t("service:full_service_title")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "4vw", md: "18px" },
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              {t("service:full_service_description")}
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* Contact Section */}
      <Box
        sx={{
          background: "#f5f5f5",
          py: { xs: 6, md: 8 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: { xs: "6vw", md: "32px" },
              fontWeight: 600,
              color: "#000",
              mb: 3,
              textTransform: "uppercase",
            }}
          >
            {t("service:contact_title")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <LocalPhoneIcon
              sx={{
                fontSize: { xs: "8vw", md: "48px" },
                color: "#000",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "6vw", md: "36px" },
                fontWeight: 700,
                color: "#000",
              }}
            >
              +373 79 200 221
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Service;